export const baseUrl=`/`;

export const otpSendApi=`${baseUrl}api/v1/check-email-and-send-otp`;

export const verifyOtpApi=`${baseUrl}api/v1/verify-otp-of-account-deletion`;